import React, { useState, useEffect, useMemo } from "react";
import Template from "../../components/Template";
import api from "../../services/api";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../components/ConfirmationModal";
import SuccessModal from "../../components/SuccessModal";
import { formatCurrencyFromDb, maskCep, maskCurrency, maskPhone } from "../../utils/masks";
import { parseCurrencyToFloat } from "../../utils/utils";
import FormLabel from "../../components/FormLabel";
import config from "../../config";
import { formatDateWithHour, formatDateWithoutHour } from "../../utils/date";
import usePermission from "../../hooks/usePermission";
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import logoEmpresa from "../../components/logoEmpresaBase64";
import { useAuth } from '../../context/AuthContext';

const CadastrarObra = ({ obraId }) => {
    const navigate = useNavigate();
    const { auth } = useAuth();
    const isEditMode = Boolean(obraId);
    const podeDeletar = usePermission("DELETAR_OBRA");
    const podeEmitirRelatorio = usePermission("DOWNLOAD_RELATORIO_OBRA");

    const [showConfirmDialog, setShowConfirmDialog] = useState(false);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const [tiposObra, setTiposObra] = useState([]);
    const [tiposDocumentos, setTiposDocumentos] = useState([]);
    const [editais, setEditais] = useState([]);
    const [contratos, setContratos] = useState([]);
    const [empenhos, setEmpenhos] = useState([]);
    const [prestadores, setPrestadores] = useState([]);
    const [catalogos, setCatalogos] = useState([]);
    const [statusList, setStatusList] = useState([])
    const [statusMedicaoList, setStatusMedicaoList] = useState([])
    const [clientes, setClientes] = useState([]);

    const [anexosSelecionados, setAnexosSelecionados] = useState([]);
    const [anexosRemovidos, setAnexosRemovidos] = useState([]);
    const [medicoesRemovidas, setMedicoesRemovidas] = useState([]);

    // Prestadores: state que guarda os prestadores já vinculados à obra
    const [prestadoresObra, setPrestadoresObra] = useState([]);
    const [prestadoresObraRemovidos, setPrestadoresObraRemovidos] = useState([]);

    const [itensOrcamento, setItensOrcamento] = useState([]);
    const [itensOrcamentoRemovidos, setItensOrcamentoRemovidos] = useState([]);

    const [anexoFile, setAnexoFile] = useState(null);

    const [medicoes, setMedicoes] = useState([]);

    const [showDialog, setShowDialog] = useState(false);
    const [selectedPdf, setSelectedPdf] = useState("");

    const [showConfirmDeleteRegister, setShowConfirmDeleteRegister] = useState(false);
    const [showConfirmRemoveArchiveDialog, setShowConfirmRemoveArchiveDialog] = useState(false);
    const [showDeleteErrorDialog, setShowDeleteErrorDialog] = useState(false);
    const [deleteErrorMessage, setDeleteErrorMessage] = useState(null);

    const [semanas, setSemanas] = useState([]);

    const [valorMaterial, setValorMaterial] = useState([]);

    const [weekForm, setWeekForm] = useState({
        dataInicio: "",
        dataTermino: "",
        valorPrevisto: "",
        previstoPercentual: "",
        valorRealizado: "",
        realizadoPercentual: "",
        prestador: "",
    });

    const [valorServico, setValorServico] = useState(0);
    const [servicos, setServicos] = useState([]);

    // Estado principal do formulário
    const [formData, setFormData] = useState({
        codigoProjeto: "",
        nomeProjeto: "",
        descricaoProjeto:
            "",
        tipoObra: "",
        enderecoObra: "",
        bairro: "",
        cep: "",
        municipio: "",
        uf: "",
        editalVinculado: "",
        contratoVinculado: "",
        empenho: "",
        numeroEmpenho: "",
        orcamentoProjeto: "",
        orcamentoProjetoReceber: "",
        dataInicio: "",
        dataTermino: "",
        numeroArt: "",
        responsavelArt: "",
        responsavelProjeto: "",
        contatoResponsavel: "",
        emailResponsavel: "",
        statusObra: "",
        observacoes: "",
        prestador: "",
        tipoDocumentoAnexo: "",
        statusEmpenho: "",
        saldoMedir: "",

        valorMedidoLiquido: "", // Valor medido líquido (campo de medições — Acompanhamento Financeiro)

        catalogo: "",           // ID do catálogo selecionado
        quantidadeItem: "",     // Quantidade digitada
        valorUnitarioItem: "",  // Valor unitário digitado
        observacaoItem: "",     // Observação do item
        cliente: ""
    });

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [tiposDocumentosRes, editaisRes, contratosRes, statusRes, prestadoresRes, tiposObraRes, catalogosRes, statusMedicaoRes, empenhoRes, clienteRes] = await Promise.all([
                    api.get("/tiposdocumentos"),
                    api.get("/editais/todos"),
                    api.get("/obras/contratos/disponiveis"),
                    api.get("/statuses/byModule/nome/obras"),
                    api.get("/fornecedores/prestadores/todos"),
                    api.get("/tiposobra"),
                    api.get("/catalogos"),
                    api.get("/statuses/byModule/nome/medicoes"),
                    api.get("/orcamentos/todos"),
                    api.get("/clientes/todos"),


                ]);
                setTiposDocumentos(tiposDocumentosRes.data);
                setEditais(editaisRes.data);
                setContratos(contratosRes.data);
                setStatusList(statusRes.data);
                setPrestadores(prestadoresRes.data);
                setTiposObra(tiposObraRes.data);
                setCatalogos(catalogosRes.data);
                setStatusMedicaoList(statusMedicaoRes.data);
                setEmpenhos(empenhoRes.data);
                setClientes(clienteRes.data);

            } catch (error) {
                console.error("Erro ao carregar dados:", error);
            }
        };
        fetchData();
        if (isEditMode) {
            const fetchObra = async () => {
                try {
                    const response = await api.get(`/obras/${obraId}`);
                    const data = response.data;
                    let valorTotalContasMedicoesReceber = 0;

                    if (data.contasReceberMedicoes && Array.isArray(data.contasReceberMedicoes)) {
                        valorTotalContasMedicoesReceber = data.contasReceberMedicoes.reduce(
                            (acc, med) => acc + (parseFloat(med.valor) || 0),
                            0
                        );
                    }

                    //const saldoOrcamentoReceber = data.orcamentoProjetoReceber - valorTotalContasMedicoesReceber;

                    setFormData((prev) => ({
                        ...prev,
                        codigoProjeto: data.codigoProjeto || "",
                        nomeProjeto: data.nomeProjeto || "",
                        descricaoProjeto: data.descricaoProjeto || "",
                        tipoObra: data.tipoObra?.id || "",
                        enderecoObra: data.enderecoObra || "",
                        bairro: data.bairro || "",
                        cep: data.cep || "",
                        municipio: data.municipio || "",
                        uf: data.uf || "",
                        editalVinculado: data.editalVinculadoId || "",
                        contratoVinculado: data.contratoId || "",
                        empenho: data.orcamentoId || "",
                        numeroEmpenho: data.numeroEmpenho || "",
                        orcamentoProjeto: data.orcamentoProjeto
                            ? formatCurrencyFromDb(data.orcamentoProjeto)
                            : "",
                        orcamentoProjetoReceber: data.orcamentoProjetoReceber != null
                            ? formatCurrencyFromDb(data.orcamentoProjetoReceber)
                            : "",
                        dataInicio: data.dataInicio ? data.dataInicio.split("T")[0] : "",
                        dataTermino: data.dataTermino ? data.dataTermino.split("T")[0] : "",
                        numeroArt: data.numeroArt || "",
                        responsavelArt: data.responsavelArt || "",
                        responsavelProjeto: data.responsavelProjeto || "",
                        contatoResponsavel: data.contatoResponsavel || "",
                        emailResponsavel: data.emailResponsavel || "",
                        statusObra: data.statusId || "",
                        observacoes: data.observacoes || "",
                        saldoMedir: data.saldoMedir ? formatCurrencyFromDb(data.saldoMedir) : "",
                        cliente: data.clienteId || ""
                        // ...
                    }));

                    // Se o backend retornou "acompanhamentoSemanal" ou "semanas"
                    if (data.acompanhamentosSemana) {
                        // Cada registro possui dataInicio/dataTermino em UTC
                        // Se quiser, converta para "YYYY-MM-DD" para exibir
                        const semanasFormatadas = data.acompanhamentosSemana.map((sem) => ({
                            ...sem,
                            // Converta datas para "YYYY-MM-DD"
                            id: sem.id,
                            dataInicio: sem.dataInicio
                                ? sem.dataInicio.split("T")[0]
                                : "",
                            dataTermino: sem.dataTermino
                                ? sem.dataTermino.split("T")[0]
                                : "",
                            valorPrevisto: sem.valorPrevisto
                                ? maskCurrency(Math.round(parseFloat(sem.valorPrevisto) * 100))
                                : "",
                            valorRealizado: sem.valorRealizado
                                ? maskCurrency(Math.round(parseFloat(sem.valorRealizado) * 100))
                                : "",
                            prestador: sem.prestadorId ?? ''
                            // etc, caso precise ajustar percentuais
                        }));
                        setSemanas(semanasFormatadas);
                    }

                    if (data.notas) {
                        // Soma todos os valorNfe
                        const somaNotas = data.notas.reduce((acc, nota) => {
                            return acc + (+nota.valorNfe || 0);
                        }, 0);

                        // Atualiza o state que será usado em "Valor Material (R$)"
                        setValorMaterial(somaNotas);
                    }

                    // Ajusta as medições já cadastradas
                    if (data.medicoes) {
                        setMedicoes(data.medicoes);

                        // 🔹 Soma todas as medições existentes
                        const totalMedicoes = data.medicoes.reduce(
                            (acc, medicao) => acc + (+medicao.valorMedido || 0),
                            0
                        );

                        // 🔹 Atualiza o saldo a medir com base no orçamento a receber e total de medições
                        const orcamentoTotal = data.orcamentoProjetoReceber;
                        const saldoMedirCalculado = orcamentoTotal - totalMedicoes;

                        // 🔹 Atualiza os estados com os novos valores
                        setFormData((prev) => ({
                            ...prev,
                            acumulado: maskCurrency(totalMedicoes.toFixed(2)),
                            saldoMedir: maskCurrency(saldoMedirCalculado.toFixed(2)),
                        }));
                    }

                    if (data.orcamentosPrestadores && data.orcamentosPrestadores.length > 0) {
                        const totalOrcamento = data.orcamentosPrestadores.reduce(
                            (acumulado, item) => acumulado + (parseFloat(item.valor) || 0),
                            0
                        );
                        // Se no seu sistema os valores devem ser convertidos (por exemplo, multiplicando por 100)
                        setFormData((prev) => ({
                            ...prev,
                            orcamentoProjeto: maskCurrency(Math.round(totalOrcamento * 100))
                        }));
                    }

                    if (data.notasServico && data.notasServico.length > 0) {
                        setServicos(data.notasServico);
                        const somaNotasServico = data.notasServico.reduce((acc, nota) => {
                            return acc + (parseFloat(nota.valorServico) || 0);
                        }, 0);
                        setValorServico(somaNotasServico);
                    } else {
                        setValorServico(0);
                    }

                    // Anexos que já existem
                    setAnexosSelecionados(data.anexos || []);

                    // Medições que já existem
                    setMedicoes(data.medicoes || []);

                    // Prestadores já vinculados
                    // Supondo que a API retorne algo como data.prestadoresObra
                    setPrestadoresObra(data.prestadores || []);
                    setItensOrcamento(data.obraItens || []);
                } catch (error) {
                    console.error("Erro ao carregar obra:", error);
                    alert("Erro ao carregar a obra. Tente novamente.");
                }
            };
            fetchObra();
        }
    }, [isEditMode, obraId]);

    useEffect(() => {
        // Soma o campo "valorMedido" de todas as medições
        const soma = medicoes.reduce((acc, med) => acc + (med.valorMedido || 0), 0);

        // Atualiza o formData.acumulado com a máscara de moeda
        setFormData((prevForm) => ({
            ...prevForm,
            acumulado: maskCurrency(soma.toFixed(2)),
        }));
    }, [medicoes]);

    // Submeter formulário
    const handleSubmit = (e) => {
        e.preventDefault();
        setShowConfirmDialog(true);
    };

    const handleConfirmSubmit = async () => {
        setShowConfirmDialog(false);
        try {
            const dataToSend = new FormData();
            dataToSend.append("nomeProjeto", formData.nomeProjeto);
            dataToSend.append("descricaoProjeto", formData.descricaoProjeto);
            dataToSend.append("tipoObra", formData.tipoObra);
            dataToSend.append("enderecoObra", formData.enderecoObra);
            dataToSend.append("bairro", formData.bairro);
            dataToSend.append("cep", formData.cep);
            dataToSend.append("municipio", formData.municipio);
            dataToSend.append("uf", formData.uf);
            dataToSend.append("editalVinculado", formData.editalVinculado);
            dataToSend.append("contratoVinculado", formData.contratoVinculado);
            dataToSend.append("empenho", formData.empenho);
            dataToSend.append("numeroEmpenho", formData.numeroEmpenho);
            dataToSend.append("orcamentoProjeto", parseCurrencyToFloat(formData.orcamentoProjeto));
            dataToSend.append("orcamentoProjetoReceber", parseCurrencyToFloat(formData.orcamentoProjetoReceber));
            dataToSend.append("dataInicio", formData.dataInicio);
            dataToSend.append("dataTermino", formData.dataTermino);
            dataToSend.append("numeroArt", formData.numeroArt);
            dataToSend.append("responsavelArt", formData.responsavelArt);
            dataToSend.append("responsavelProjeto", formData.responsavelProjeto);
            dataToSend.append("contatoResponsavel", formData.contatoResponsavel);
            dataToSend.append("emailResponsavel", formData.emailResponsavel);
            dataToSend.append("statusObra", formData.statusObra);
            dataToSend.append("observacoes", formData.observacoes);
            dataToSend.append("saldoMedir", parseCurrencyToFloat(formData.saldoMedir));

            dataToSend.append("anexosRemovidos", JSON.stringify(anexosRemovidos));
            dataToSend.append("medicoesRemovidas", JSON.stringify(medicoesRemovidas));

            dataToSend.append("medicoes", JSON.stringify(medicoes));
            dataToSend.append("cliente", formData.cliente);
            anexosSelecionados.forEach((anexo, index) => {
                if (anexo.isNew && anexo.file) {
                    dataToSend.append(`anexos[${index}][tipoId]`, anexo.tipoId);
                    dataToSend.append(`anexosFiles[${index}]`, anexo.file, anexo.file.name);
                    dataToSend.append(`anexos[${index}][dataEnvio]`, anexo.dataEnvio);
                    dataToSend.append(`anexos[${index}][isNew]`, anexo.isNew);
                }
            });

            // Prestadores
            dataToSend.append("prestadoresObra", JSON.stringify(prestadoresObra));
            dataToSend.append("prestadoresObraRemovidos", JSON.stringify(prestadoresObraRemovidos));

            dataToSend.append("itensOrcamento", JSON.stringify(itensOrcamento));
            dataToSend.append("itensOrcamentoRemovidos", JSON.stringify(itensOrcamentoRemovidos));

            if (isEditMode) {
                await api.put(`/obras/${obraId}`, dataToSend, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            } else {
                await api.post(`/obras`, dataToSend, {
                    headers: { "Content-Type": "multipart/form-data" },
                });
            }

            setShowSuccessDialog(true);
            setTimeout(() => {
                setShowSuccessDialog(false);
                if (isEditMode) {
                    window.location.href = `/obras/editar/${obraId}`;
                } else {
                    window.location.href = `/obras`;
                }
            }, 3000);
        } catch (error) {
            console.error(`Erro ao ${isEditMode ? "atualizar" : "cadastrar"} obras:`, error);
            alert("Ocorreu um erro. Verifique os dados e tente novamente.");
        }
    };

    const handleCancelSubmit = () => {
        setShowConfirmDialog(false);
    };

    // Botão Voltar
    const handleBack = () => {
        navigate("/obras");
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    // Handler específico para campo de telefone
    const handlePhoneChange = (e) => {
        const originalValue = e.target.value;
        const masked = maskPhone(originalValue);
        setFormData((prev) => ({ ...prev, contatoResponsavel: masked }));
    };

    // Handler específico para campo de moeda
    const handleCurrencyChange = (fieldName) => (e) => {
        const originalValue = e.target.value;
        const masked = maskCurrency(originalValue);
        setFormData((prev) => ({ ...prev, [fieldName]: masked }));
    };

    const handleAdicionarMedicao = () => {
        if (!formData.valorMedido) {
            alert("Preencha o campo 'Valor do Medido' corretamente.");
            return;
        }

        const novoValorMedido = parseCurrencyToFloat(formData.valorMedido);

        // Verifica se 'Nº Nota Fiscal' foi preenchido
        if (!formData.numeroMedicao) {
            alert("Preencha o campo 'Nº Nota Fiscal'.");
            return;
        }


        // Verifica status
        const statusId = parseInt(formData.statusMedicao, 10);
        if (!statusId) {
            alert("Selecione um 'Status'.");
            return;
        }
        const statusEncontrado = statusList.find((s) => s.id === statusId);
        if (!statusEncontrado) {
            alert("O status selecionado não é válido.");
            return;
        }

        // Verifica se campo 'Período' está preenchido
        if (!formData.periodo) {
            alert("Selecione o 'Período'.");
            return;
        }

        // Verifica se 'Nº Nota Fiscal' foi preenchido
        if (!formData.numeroNotaFiscal) {
            alert("Preencha o campo 'Nº Nota Fiscal'.");
            return;
        }

        // Verifica se 'Nº Empenho' foi preenchido
        if (!formData.numeroMedicaoEmpenho) {
            alert("Preencha o campo 'Nº Empenho'.");
            return;
        }

        setMedicoes((prevMedicoes) => {
            const novasMedicoes = [
                ...prevMedicoes,
                {
                    id: Date.now(), // ID único local
                    valorMedido: novoValorMedido,
                    valorMedidoLiquido: formData.valorMedidoLiquido
                        ? parseCurrencyToFloat(formData.valorMedidoLiquido)
                        : null,
                    numeroNotaFiscal: formData.numeroNotaFiscal,
                    periodo: formData.periodo,
                    statusNome: statusEncontrado.nome,
                    statusMedicao: formData.statusMedicao,
                    numeroMedicaoEmpenho: formData.numeroMedicaoEmpenho,
                    numeroMedicao: formData.numeroMedicao,
                    dataEnvio: Date.now(),
                    isNew: true,
                },
            ];

            // 🔹 Soma o total de valores medidos
            const totalMedicoes = novasMedicoes.reduce(
                (acc, medicao) => acc + (medicao.valorMedido || 0),
                0
            );

            // 🔹 Subtrai o total do orçamento do projeto a receber
            const orcamentoTotal = parseCurrencyToFloat(formData.orcamentoProjetoReceber);
            const saldoMedir = orcamentoTotal - totalMedicoes;

            // 🔹 Atualiza o estado do formulário com o novo saldo a medir
            setFormData((prev) => ({
                ...prev,
                saldoMedir: maskCurrency(saldoMedir.toFixed(2)), // Atualiza o saldo a medir
            }));

            return novasMedicoes;
        });

        // Limpa os campos do formulário
        setFormData((prev) => ({
            ...prev,
            valorMedido: '',
            valorMedidoLiquido: '',
            numeroNotaFiscal: '',
            periodo: '',
            statusMedicao: '',
            numeroMedicaoEmpenho: '',
            numeroMedicao: ''
        }));
    };

    const handleApagarMedicao = (id) => {
        setMedicoes((prevMedicoes) => {
            // 1) Localiza a medição
            const item = prevMedicoes.find((a) => a.id === id);
            if (!item) return prevMedicoes; // se não achar, não faz nada

            // 2) Se for uma medição nova (não persistida no backend)
            if (item.isNew || String(item.id).startsWith('temp-')) {
                const novasMedicoes = prevMedicoes.filter((a) => a.id !== id);

                // 🔹 Recalcula o acumulado com base nas novas medições
                const totalMedicoes = novasMedicoes.reduce(
                    (acc, med) => acc + (med.valorMedido || 0),
                    0
                );

                // 🔹 Atualiza o saldo a medir
                const orcamentoTotal = parseCurrencyToFloat(formData.orcamentoProjetoReceber);
                const novoSaldoMedir = orcamentoTotal - totalMedicoes;

                // 🔹 Atualiza os estados
                setFormData((prev) => ({
                    ...prev,
                    acumulado: maskCurrency(totalMedicoes.toFixed(2)),
                    saldoMedir: maskCurrency(novoSaldoMedir.toFixed(2)),
                }));

                return novasMedicoes;
            } else {
                // 3) Adiciona a medição removida em um array separado (se ainda não estiver lá)
                setMedicoesRemovidas((prevRemovidos) => {
                    const jaExiste = prevRemovidos.some((r) => r.id === item.id);
                    if (!jaExiste) {
                        return [...prevRemovidos, item];
                    }
                    return prevRemovidos;
                });

                // 4) Remove a medição do array principal
                const novasMedicoes = prevMedicoes.filter((a) => a.id !== id);

                // 🔹 Recalcula o acumulado com base nas novas medições
                const totalMedicoes = novasMedicoes.reduce(
                    (acc, med) => acc + (med.valorMedido || 0),
                    0
                );

                // 🔹 Atualiza o saldo a medir
                const orcamentoTotal = parseCurrencyToFloat(formData.orcamentoProjetoReceber);
                const novoSaldoMedir = orcamentoTotal - totalMedicoes;

                // 🔹 Atualiza os estados
                setFormData((prev) => ({
                    ...prev,
                    acumulado: maskCurrency(totalMedicoes.toFixed(2)),
                    saldoMedir: maskCurrency(novoSaldoMedir.toFixed(2)),
                }));

                return novasMedicoes;
            }
        });
    };

    const handleAnexoFileChange = (e) => {
        setAnexoFile(e.target.files[0]);
    };

    // Manipulador para adicionar um novo anexo
    const handleAddAnexo = () => {
        if (!formData.tipoDocumentoAnexo) {
            alert("Selecione um Tipo de Documento antes de enviar.");
            return;
        }
        if (!anexoFile) {
            alert("Selecione um arquivo antes de enviar.");
            return;
        }

        // Encontrar no array "tiposDocumentos" o objeto do tipo selecionado
        const tipoId = parseInt(formData.tipoDocumentoAnexo, 10);
        const tipoEncontrado = tiposDocumentos.find((t) => t.id === tipoId);
        if (!tipoEncontrado) {
            alert("Tipo de documento não encontrado.");
            return;
        }

        // Cria objeto com tipo, file, data de envio, etc.
        const novoAnexo = {
            id: Date.now(), // ID único local
            tipoId: tipoId,
            tipoNome: tipoEncontrado.nome,
            file: anexoFile,
            dataEnvio: new Date().toISOString(),
            isNew: true,
        };
        setAnexosSelecionados((prev) => [...prev, novoAnexo]);
        setAnexoFile(null); // Resetar o campo de arquivo
    };

    const handleRemoveAnexo = (anexoId) => {
        setAnexosSelecionados((prevSelecionados) => {
            // 1) Localiza o anexo
            const item = prevSelecionados.find((a) => a.id === anexoId);
            if (!item) return prevSelecionados; // se não achar, não faz nada

            // 2) Se é novo (isNew === true) ou ID temporário (p. ex.: 'temp-...'),
            //    basta remover do array principal, pois não precisa excluir no backend.
            if (item.isNew || String(item.id).startsWith('temp-')) {
                return prevSelecionados.filter((a) => a.id !== anexoId);
            } else {
                // 3) Caso contrário, movemos para anexosRemovidos,
                //    MAS evitamos duplicar caso já esteja lá.
                setAnexosRemovidos((prevRemovidos) => {
                    const jaExiste = prevRemovidos.some((r) => r.id === item.id);
                    if (!jaExiste) {
                        return [...prevRemovidos, item];
                    }
                    return prevRemovidos;
                });

                // 4) E removemos do array principal
                return prevSelecionados.filter((a) => a.id !== anexoId);
            }
        });
    };

    const handleShowPdf = (url) => {
        setSelectedPdf(url);
        setShowDialog(true);
    };

    const handleCloseDialog = () => {
        setShowDialog(false);
    };

    // Manipulador para apagar o contrato (apenas no modo de edição)
    const handleDeleteRegister = async () => {
        try {
            await api.delete(`/obras/${obraId}`);
            setShowConfirmDeleteRegister(false);
            navigate("/obras");
        } catch (error) {
            console.error("Erro ao remover obra:", error);
            setShowConfirmDeleteRegister(false);
            if (error.response?.status === 409 && error.response?.data) {
                setDeleteErrorMessage({
                    titulo: "Esta obra não pode ser removida",
                    descricao: `A obra está em uso no sistema e possui vínculos que impedem a exclusão.`,
                    dependencias: error.response.data.dependencias || [],
                });
            } else {
                setDeleteErrorMessage({
                    titulo: "Erro ao remover obra",
                    descricao: "Ocorreu um erro inesperado. Tente novamente mais tarde.",
                    dependencias: [],
                });
            }
            setShowDeleteErrorDialog(true);
        }
    };

    const handleCepChange = (e) => {
        const value = e.target.value;
        // Aplica a máscara
        const maskedValue = maskCep(value);
        setFormData((prev) => ({
            ...prev,
            cep: maskedValue,
        }));
    };

    // Busca o endereço pelo CEP usando ViaCEP
    const fetchAddressByCep = async () => {
        if (!formData.cep || formData.cep.length < 8) {
            alert("Insira um CEP válido.");
            return;
        }

        try {
            const response = await fetch(`https://viacep.com.br/ws/${formData.cep}/json/`);
            const data = await response.json();

            if (data.erro) {
                alert("CEP não encontrado.");
                return;
            }

            // Atualiza os campos de endereço, município e estado
            setFormData((prev) => ({
                ...prev,
                enderecoObra: data.logradouro || "",
                municipio: data.localidade || "",
                bairro: data.bairro || "",
                uf: data.uf || "",
            }));
        } catch (error) {
            console.error("Erro ao buscar o endereço:", error);
            alert("Não foi possível buscar o endereço. Tente novamente.");
        }
    };

    // Função para exportar relatório
    const exportarRelatorio = () => {
        const doc = new jsPDF();

        let posY = 20;

        // Título do relatório
        doc.setFontSize(16);
        doc.text(`Relatório Financeiro da Obra - (${formData.codigoProjeto}) ${formData.nomeProjeto}`, 14, posY);
        posY += 10;

        const orcamentoReceber = formData.orcamentoProjetoReceber;
        const valorMateriais = valorMaterial;

        const valorTotalServicos = servicos.reduce((acc, nota) => {
            return acc + (parseFloat(nota.valorServico) || 0);
        }, 0);

        // Tabela inicial (Valores gerais)
        autoTable(doc, {
            startY: posY,
            headStyles: { fillColor: [30, 120, 180] },
            head: [['Descrição', 'Valor (R$)']],
            body: [
                ['Orçamento a Receber', orcamentoReceber],
                ['Total Materiais', valorMateriais.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
                ['Total Serviços', valorTotalServicos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
            ],
        });

        posY = doc.lastAutoTable.finalY + 10;

        // Tabela detalhada dos prestadores
        if (servicos.length > 0) {
            const tabelaPrestadores = servicos.map((nota) => [
                nota?.fornecedor?.nomeFornecedor || 'N/A',
                parseFloat(nota.valorServico || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
            ]);

            autoTable(doc, {
                startY: posY,
                headStyles: { fillColor: [30, 120, 180] },
                head: [['Prestador de Serviço', 'Valor (R$)']],
                body: tabelaPrestadores,
            });

            posY = doc.lastAutoTable.finalY + 10;
        }

        // Saldo final
        const saldoFinal = parseCurrencyToFloat(orcamentoReceber) - valorMateriais - valorTotalServicos;

        autoTable(doc, {
            startY: posY,
            headStyles: { fillColor: [30, 120, 180] },
            head: [['Descrição', 'Valor (R$)']],
            body: [
                ['Orçamento a Receber', orcamentoReceber],
                ['(-) Materiais', valorMateriais.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
                ['(-) Serviços', valorTotalServicos.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
                ['Saldo Final', saldoFinal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })],
            ],
        });

        const paginas = doc.getNumberOfPages();
        const usuarioAtual = auth.user.name;
        const dataEmissao = new Date().toLocaleString('pt-BR');

        for (let i = 1; i <= paginas; i++) {
            doc.setPage(i);

            doc.setFontSize(8);
            doc.setTextColor(100);
            doc.text(`Emitido por: ${usuarioAtual}`, 14, 285);
            doc.text(`Data/Hora: ${dataEmissao}`, 14, 290);
            doc.text(`Página ${i} de ${paginas}`, 195, 290, { align: 'right' });

            const logoWidth = 50;
            const logoHeight = 15;
            const pageWidth = doc.internal.pageSize.getWidth();
            const logoX = (pageWidth - logoWidth) / 2;
            const logoY = 270;

            doc.addImage(logoEmpresa, 'PNG', logoX, logoY, logoWidth, logoHeight);
        }

        doc.save(`relatorio-financeiro-obra-${formData.nomeProjeto}.pdf`);
    };

    return (
        <Template>
            <form onSubmit={handleSubmit} className="w-full px-4 py-6 flex flex-col gap-8">
                {/* Título da Página */}
                <div>
                    <h1 className="text-2xl text-stone-800 font-medium">
                        {isEditMode ? "Editar Obra" : "Cadastrar Obra"}
                    </h1>
                </div>

                {/* Informações Básicas */}
                <div className="flex flex-col gap-4">
                    <div className="text-stone-600 text-base font-medium">Informações Básicas</div>

                    {/* Primeira linha */}
                    <div className="flex flex-col lg:flex-row lg:items-end gap-4 w-full">
                        <div className="flex-[4] flex flex-col gap-1.5">
                            <FormLabel htmlFor={"nomeProjetp"} isRequired={true}>Nome da Obra</FormLabel>

                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="nomeProjeto"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.nomeProjeto}
                                    onChange={handleInputChange}
                                    required
                                />
                            </div>
                        </div>
                        <div className="flex-1 min-w-[250px] flex flex-col gap-1.5">
                            <FormLabel htmlFor={"cliente"} isRequired={true}>Cliente</FormLabel>

                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <select
                                    name="cliente"
                                    value={formData.cliente}
                                    onChange={handleInputChange}
                                    className="w-full bg-transparent outline-none text-slate-700 text-base truncate"
                                    title={clientes.find(c => c.id === parseInt(formData.cliente))?.nome || "Selecionar"}
                                >
                                    <option value="">Selecionar</option>
                                    {clientes.map((objeto) => (
                                        <option key={objeto.id} value={objeto.id} title={objeto.nome}>
                                            {objeto.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Segunda linha */}
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Descrição da Obra</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    name="descricaoProjeto"
                                    className="text-slate-700 text-base outline-none w-full resize-none"
                                    value={formData.descricaoProjeto}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="w-full md:w-[375px] flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Tipo de Obra</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <select
                                    name="tipoObra"
                                    value={formData.tipoObra}
                                    onChange={handleInputChange}
                                    className="grow bg-transparent outline-none text-slate-700 text-base"
                                >
                                    <option value="">Selecionar</option>
                                    {tiposObra.map((objeto) => (
                                        <option key={objeto.id} value={objeto.id}>
                                            {objeto.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Localização */}
                <div className="flex flex-col gap-4">
                    <div className="text-stone-600 text-base font-medium">Localização</div>
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="w-full md:w-[375px] flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">CEP</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="cep"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.cep || ""}
                                    onChange={handleCepChange}
                                    onBlur={fetchAddressByCep}
                                />
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Endereço</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="enderecoObra"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.enderecoObra}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Bairro</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="bairro"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.bairro}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Município</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="municipio"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.municipio}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="w-full md:w-[108px] flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">UF</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <select
                                    name="uf"
                                    className="grow bg-transparent outline-none text-slate-700 text-base"
                                    value={formData.uf}
                                    onChange={handleInputChange}
                                >
                                    <option value="">Selecione</option>
                                    <option value="AC">AC</option>
                                    <option value="AL">AL</option>
                                    <option value="AP">AP</option>
                                    <option value="AM">AM</option>
                                    <option value="BA">BA</option>
                                    <option value="CE">CE</option>
                                    <option value="DF">DF</option>
                                    <option value="ES">ES</option>
                                    <option value="GO">GO</option>
                                    <option value="MA">MA</option>
                                    <option value="MT">MT</option>
                                    <option value="MS">MS</option>
                                    <option value="MG">MG</option>
                                    <option value="PA">PA</option>
                                    <option value="PB">PB</option>
                                    <option value="PR">PR</option>
                                    <option value="PE">PE</option>
                                    <option value="PI">PI</option>
                                    <option value="RJ">RJ</option>
                                    <option value="RN">RN</option>
                                    <option value="RS">RS</option>
                                    <option value="RO">RO</option>
                                    <option value="RR">RR</option>
                                    <option value="SC">SC</option>
                                    <option value="SP">SP</option>
                                    <option value="SE">SE</option>
                                    <option value="TO">TO</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Informações do Edital e Empenho */}
                <div className="flex flex-col gap-4">
                    <div className="text-stone-600 text-base font-medium">Informações do Edital e Empenho</div>
                    
                    {/* Primeira linha - Edital e Contrato */}
                    <div className="flex flex-col lg:flex-row gap-4">
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Edital Vinculado</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <select
                                    name="editalVinculado"
                                    className="w-full bg-transparent outline-none text-slate-700 text-base truncate"
                                    value={formData.editalVinculado}
                                    onChange={handleInputChange}
                                    title={editais.find(e => e.id === parseInt(formData.editalVinculado))?.numeroEdital || "Selecionar"}
                                >
                                    <option value="">Selecionar</option>
                                    {editais.map((objeto) => (
                                        <option key={objeto.id} value={objeto.id} title={objeto.numeroEdital}>
                                            {objeto.numeroEdital}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Contrato Vinculado</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <select
                                    name="contratoVinculado"
                                    className="w-full bg-transparent outline-none text-slate-700 text-base truncate"
                                    value={formData.contratoVinculado}
                                    onChange={handleInputChange}
                                    title={contratos.find(c => c.id === parseInt(formData.contratoVinculado))?.numeroContrato || "Selecionar"}
                                >
                                    <option value="">Selecionar</option>
                                    {contratos.map((contrato) => (
                                        <option key={contrato.id} value={contrato.id} title={`${contrato.numeroContrato} - ${contrato.objetoContrato}`}>
                                            {contrato.numeroContrato} - {contrato.objetoContrato}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div>

                    {/* Segunda linha - Empenho e Número */}
                    <div className="flex flex-col lg:flex-row gap-4">
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Empenho</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <select
                                    name="empenho"
                                    className="w-full bg-transparent outline-none text-slate-700 text-base truncate"
                                    value={formData.empenho}
                                    onChange={handleInputChange}
                                    title={empenhos.find(e => e.id === parseInt(formData.empenho))?.codigoOrcamento || "Selecionar"}
                                >
                                    <option value="">Selecionar</option>
                                    {empenhos.map((objeto) => (
                                        <option key={objeto.id} value={objeto.id} title={objeto.codigoOrcamento}>
                                            {objeto.codigoOrcamento}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Número do Empenho</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="numeroEmpenho"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.numeroEmpenho}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Orçamento e Prazos */}
                <div className="flex flex-col gap-4">
                    <div className="text-stone-600 text-base font-medium">Orçamento e Prazos</div>
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">
                                Orçamento da Obra - Pagar (R$)
                            </label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="orcamentoProjeto"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.orcamentoProjeto}
                                    onChange={handleCurrencyChange("orcamentoProjeto")}
                                />
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">
                                Orçamento da Obra - Receber(R$)
                            </label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="orcamentoProjetoReceber"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.orcamentoProjetoReceber}
                                    onChange={handleCurrencyChange("orcamentoProjetoReceber")}
                                />
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Data de Início</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="date"
                                    name="dataInicio"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.dataInicio}
                                    onChange={handleInputChange}

                                />
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Data do Término</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="date"
                                    name="dataTermino"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.dataTermino}
                                    onChange={handleInputChange}


                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Itens Detalhados do Orçamento */}
                <div className="flex flex-col gap-4">
                    {/* Resumo valores */}
                    <div className="flex flex-col md:flex-row">
                        <div className="flex-1 flex flex-col">
                            <div className="px-4 py-2 bg-stone-200 border border-slate-200 text-center font-bold">
                                Valor Material (R$)
                            </div>
                            <div className="px-4 py-2 bg-white border border-slate-200 text-center">
                                {valorMaterial.toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                })}
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col">
                            <div className="px-4 py-2 bg-stone-200 border border-slate-200 text-center font-bold">
                                Valor Serviço (R$)
                            </div>
                            <div className="px-4 py-2 bg-white border border-slate-200 text-center">
                                {valorServico.toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                })}
                            </div>
                        </div>

                    </div>
                    <div className="flex flex-col md:flex-row">
                        <div className="flex-1 flex flex-col">
                            <div className="px-4 py-2 bg-stone-200 border border-slate-200 text-center font-bold">
                                Custo (R$)
                            </div>
                            <div className="px-4 py-2 bg-white border border-slate-200 text-center">
                                {(valorServico + valorMaterial).toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                })}
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col">
                            <div className="px-4 py-2 bg-stone-200 border border-slate-200 text-center font-bold">
                                Saldo (R$)
                            </div>
                            {/* Calcular saldo numa variável */}
                            {(() => {
                                const orcamentoReceber = parseCurrencyToFloat(formData.orcamentoProjetoReceber);
                                const servico = valorServico ?? 0;
                                const material = valorMaterial ?? 0;

                                const saldo = (isNaN(orcamentoReceber) ? 0 : orcamentoReceber) - (((isNaN(servico) ? 0 : servico) + (isNaN(material) ? 0 : material)));

                                // 2) Escolher cor de texto
                                let corSaldo = "text-blue-600";      // Se for == 0
                                if (saldo > 0) corSaldo = "text-green-600";
                                if (saldo < 0) corSaldo = "text-red-600";

                                // 3) Converter para string no formato de moeda
                                const saldoMoeda = saldo.toLocaleString("pt-BR", {
                                    style: "currency",
                                    currency: "BRL",
                                });

                                return (
                                    <div className={`px-4 py-2 bg-white border border-slate-200 text-center ${corSaldo}`}>
                                        {saldoMoeda}
                                    </div>
                                );
                            })()}
                        </div>
                    </div>
                </div>

                {/* ART */}
                <div className="flex flex-col gap-4">
                    <div className="text-stone-600 text-base font-medium">ART</div>
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="w-full md:w-[375px] flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Nº da ART</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="numeroArt"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.numeroArt}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>

                        <div className="flex-1 flex flex-col gap-4">
                            <div className="flex flex-col md:flex-row gap-4">
                                <div className="flex-1 flex flex-col gap-1.5">
                                    <label className="text-slate-700 text-sm font-medium">
                                        Responsável pela ART
                                    </label>
                                    <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                        <input
                                            type="text"
                                            name="responsavelArt"
                                            className="text-slate-700 text-base outline-none w-full"
                                            value={formData.responsavelArt}
                                            onChange={handleInputChange}
                                        />
                                    </div>
                                </div>
                                {/* Espaço invisível para manter alinhamento */}
                                <div className="opacity-0 flex-1 flex flex-col gap-1.5" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Equipe Responsável */}
                <div className="flex flex-col gap-4">
                    <div className="text-stone-600 text-base font-medium">Equipe Responsável</div>
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">
                                Responsável pela Obra
                            </label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="responsavelProjeto"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.responsavelProjeto}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                        <div className="w-full md:w-[375px] flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Contato do Responsável</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="text"
                                    name="contatoResponsavel"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.contatoResponsavel}
                                    onChange={handlePhoneChange}
                                />
                            </div>
                        </div>
                        <div className="w-full md:w-[375px] flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Email do Responsável</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2">
                                <input
                                    type="email"
                                    name="emailResponsavel"
                                    className="text-slate-700 text-base outline-none w-full"
                                    value={formData.emailResponsavel}
                                    onChange={handleInputChange}
                                />
                            </div>
                        </div>
                    </div>
                </div>



                {/* Medições */}
                <div className="flex flex-col gap-4">
                    <div className="text-stone-600 text-base font-medium">Medições</div>
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="flex flex-col">
                            <label className="text-slate-700 text-sm font-medium">Número</label>
                            <input
                                type="text"
                                name="numeroMedicao"
                                value={formData.numeroMedicao}
                                onChange={handleInputChange}
                                className="mt-2 w-full px-3 py-2 bg-white rounded-md border border-slate-300"

                            />
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Valor do Medido (R$)</label>

                            <input
                                type="text"
                                name="valorMedido"
                                value={formData.valorMedido}
                                onChange={handleCurrencyChange('valorMedido')}
                                className="mt-1 w-full px-3 py-2 bg-white rounded-md border border-slate-300"

                            />

                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Valor Medido Líquido (R$)</label>

                            <input
                                type="text"
                                name="valorMedidoLiquido"
                                value={formData.valorMedidoLiquido}
                                onChange={handleCurrencyChange('valorMedidoLiquido')}
                                className="mt-1 w-full px-3 py-2 bg-white rounded-md border border-slate-300"
                                placeholder="Opcional"
                            />

                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Nº Nota Fiscal</label>
                            <input
                                type="text"
                                name="numeroNotaFiscal"
                                value={formData.numeroNotaFiscal}
                                onChange={handleInputChange}
                                className="mt-1 w-full px-3 py-2 bg-white rounded-md border border-slate-300"

                            />
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Período</label>
                            <select
                                name="periodo"
                                value={formData.periodo}
                                onChange={handleInputChange}
                                className="mt-1 w-full px-3 py-2 bg-white rounded-md border border-slate-300"

                            >
                                <option value="">Selecionar</option>
                                <option value="Janeiro">Janeiro</option>
                                <option value="Fevereiro">Fevereiro</option>
                                <option value="Março">Março</option>
                                <option value="Abril">Abril</option>
                                <option value="Maio">Maio</option>
                                <option value="Junho">Junho</option>
                                <option value="Julho">Julho</option>
                                <option value="Agosto">Agosto</option>
                                <option value="Setembro">Setembro</option>
                                <option value="Outubro">Outubro</option>
                                <option value="Novembro">Novembro</option>
                                <option value="Dezembro">Dezembro</option>
                                {/* Adicione mais opções conforme necessário */}
                            </select>
                        </div>
                    </div>
                    <div className="flex flex-col md:flex-row items-end gap-4">
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Status</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2 flex items-center justify-between">
                                <select
                                    name="statusMedicao"
                                    value={formData.statusMedicao}
                                    onChange={handleInputChange}
                                    className="grow bg-transparent outline-none text-slate-700 text-base"
                                >
                                    <option value="">Selecionar</option>
                                    {statusMedicaoList.map((objeto) => (
                                        <option key={objeto.id} value={objeto.id}>
                                            {objeto.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-medium">Nº Empenho</label>
                            <input
                                type="text"
                                name="numeroMedicaoEmpenho"
                                value={formData.numeroMedicaoEmpenho}
                                onChange={handleInputChange}
                                className="mt-1 w-full px-3 py-2 bg-white rounded-md border border-slate-300"
                            />
                        </div>
                        <button
                            type="button"
                            onClick={() => {
                                handleAdicionarMedicao();
                            }}
                            className="h-10 px-4 py-2 bg-stone-600 rounded-md inline-flex justify-center items-center gap-2"
                        >

                            <img className="w-4 h-4 overflow-hidden" src="/images/icon/plus-circle.png" />
                            <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Adicionar Medição</div>
                        </button>
                    </div>

                    {/* Tabela de Medições */}
                    <div className="overflow-x-auto">
                        <table className="border-collapse w-full min-w-max">
                            <thead>
                                <tr>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">ID</th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">Nº</th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">
                                        Valor Medido (R$)
                                    </th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">
                                        Valor Medido Líquido (R$)
                                    </th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">
                                        Nº Nota Fiscal
                                    </th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">Período</th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">
                                        Nº do Empenho
                                    </th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">Apagar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {medicoes.length > 0 ? (
                                    medicoes.map((medicao, index) => (
                                        <tr key={medicao.id}>
                                            <td className="border px-4 py-2 text-center">{medicao.id ?? index + 1}</td>
                                            <td className="border px-4 py-2 text-center">{medicao.numeroMedicao}</td>
                                            <td className="border px-4 py-2 text-center">
                                                {medicao.valorMedido.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                                            </td>
                                            <td className="border px-4 py-2 text-center">
                                                <input
                                                    type="text"
                                                    value={
                                                        medicao.valorMedidoLiquidoFormatted !== undefined
                                                            ? medicao.valorMedidoLiquidoFormatted
                                                            : (medicao.valorMedidoLiquido != null
                                                                ? maskCurrency(((+medicao.valorMedidoLiquido) * 100).toFixed(0))
                                                                : '')
                                                    }
                                                    onChange={(e) => {
                                                        const masked = maskCurrency(e.target.value);
                                                        const numero = parseCurrencyToFloat(masked);
                                                        setMedicoes((prev) =>
                                                            prev.map((m) => m.id === medicao.id
                                                                ? { ...m, valorMedidoLiquidoFormatted: masked, valorMedidoLiquido: numero || null }
                                                                : m
                                                            )
                                                        );
                                                    }}
                                                    placeholder="Opcional"
                                                    className="w-full px-2 py-1 bg-white rounded border border-slate-300 text-center"
                                                />
                                            </td>
                                            <td className="border px-4 py-2 text-center">{medicao.numeroNotaFiscal}</td>
                                            <td className="border px-4 py-2 text-center">{medicao.periodo}</td>
                                            <td className="border px-4 py-2 text-center">{medicao.numeroEmpenho ?? medicao.numeroMedicaoEmpenho}</td>
                                            <td className="border px-4 py-2 text-center">
                                                <button
                                                    type="button"
                                                    onClick={() => handleApagarMedicao(medicao.id)}
                                                    title="Remover Medição"
                                                >
                                                    <img className="w-6 h-6 px-[3px] py-0.5 flex-col justify-center items-center inline-flex overflow-hidden" src="/images/icon/trash.png" alt="Remover" title="Remover" />
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={9}
                                            className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-base text-center"
                                        >
                                            Nenhuma medição adicionada.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    {/* Acumulado / Acumulado Líquido / Saldo */}
                    <div className="flex flex-col md:flex-row">
                        <div className="flex-1 flex flex-col">
                            <div className="px-4 py-2 bg-stone-200 border border-slate-200 text-center font-bold">
                                Acumulado (R$)
                            </div>
                            <div className="px-4 py-2 bg-white border border-slate-200 text-center">
                                <input
                                    type="text"
                                    name="acumulado"
                                    value={formData.acumulado}
                                    className="w-full  rounded-md  border-slate-300 text-center"
                                    step="0.01"
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col">
                            <div className="px-4 py-2 bg-stone-200 border border-slate-200 text-center font-bold">
                                Acumulado Líquido (R$)
                            </div>
                            <div className="px-4 py-2 bg-white border border-slate-200 text-center">
                                <input
                                    type="text"
                                    name="acumuladoLiquido"
                                    value={formatCurrencyFromDb(
                                        (medicoes || []).reduce(
                                            (acc, m) => acc + (parseFloat(m.valorMedidoLiquido) || 0),
                                            0
                                        )
                                    )}
                                    className="w-full rounded-md border-slate-300 text-center"
                                    readOnly
                                />
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col">
                            <div className="px-4 py-2 bg-stone-200 border border-slate-200 text-center font-bold">
                                Saldo a Medir (R$)
                            </div>

                            <input
                                type="text"
                                name="saldoMedir"
                                value={formData.saldoMedir}
                                onChange={handleCurrencyChange('saldoMedir')}
                                className="px-4 py-2 bg-white border border-slate-200 text-center"
                                step="0.01"
                            />

                        </div>
                    </div>
                </div>

                {/* Documentação e Anexos */}
                <div className="flex flex-col gap-4">
                    <div className="text-stone-600 text-base font-medium">Documentação e Anexos</div>
                    <div className="flex flex-col md:flex-row gap-4">
                        <div className="w-full md:w-[376px] flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-normal">Tipo de Documento</label>
                            <div className="bg-white border border-slate-300 rounded-md px-3 py-2 flex items-center justify-between">
                                <select
                                    name="tipoDocumentoAnexo"
                                    value={formData.tipoDocumentoAnexo}
                                    onChange={handleInputChange}
                                    className="grow bg-transparent outline-none text-slate-700 text-base"
                                >
                                    <option value="">Selecionar</option>
                                    {tiposDocumentos.map((objeto) => (
                                        <option key={objeto.id} value={objeto.id}>
                                            {objeto.nome}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                        <div className="flex-1 flex flex-col gap-1.5">
                            <label className="text-slate-700 text-sm font-normal">Selecionar Documento</label>
                            <div className="flex gap-2">
                                <div className="relative flex items-center gap-4 w-full">
                                    <input
                                        name="arquivo"
                                        type="file"
                                        accept=".pdf"
                                        onChange={handleAnexoFileChange}
                                        className="absolute inset-0 opacity-0 cursor-pointer grow pl-3 pr-14 py-2 bg-white rounded-md border border-slate-300 text-slate-400 text-base"


                                    />
                                    <div className={`w-full pl-3 pr-14 py-2 bg-white rounded-md border border-slate-300 flex items-center gap-2`} >
                                        <span className="text-base text-slate-400">
                                            {anexoFile ? anexoFile.name : "Pesquisar Documento"}
                                        </span>
                                    </div>
                                </div>
                                <button type="button" className="px-4 py-2 bg-stone-600 rounded-md flex justify-center items-center gap-2.5" onClick={handleAddAnexo}>
                                    <div className="text-white text-sm font-normal font-['Inter'] leading-normal">
                                        Enviar
                                    </div>
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Tabela de Documentos */}
                    <div className="overflow-x-auto">
                        <table className="border-collapse w-full min-w-max">
                            <thead>
                                <tr>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">Nº</th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">Tipo</th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">Data do Envio</th>
                                    <th className="px-4 py-2 bg-stone-200 border border-slate-200">Apagar</th>
                                </tr>
                            </thead>
                            <tbody>
                                {anexosSelecionados.length > 0 ? (
                                    anexosSelecionados.map((anexo) => (
                                        <tr key={anexo.id}>
                                            <td className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-base">{anexo.id}</td>
                                            <td className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-base">{anexo.tipoNome ?? anexo.tipo.nome}</td>
                                            <td className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-base">{formatDateWithoutHour(anexo.dataEnvio)}</td>
                                            <td className="px-4 py-2 bg-white border border-slate-200 text-center">
                                                {(isEditMode && !anexo.isNew && anexo.arquivo) && (
                                                    <button type="button" onClick={() => handleShowPdf(anexo.arquivo)} title="Ver anexo">
                                                        <img className="w-10 h-10 px-[3px] py-0.5 flex-col justify-center items-center inline-flex overflow-hidden" src="/images/icon/search.png" />
                                                    </button>
                                                )}
                                                <button type="button" onClick={() => handleRemoveAnexo(anexo.id)} title="Remover anexo">
                                                    <img className="w-6 h-6 px-[3px] py-0.5 flex-col justify-center items-center inline-flex overflow-hidden" src="/images/icon/trash.png" />
                                                </button>

                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td
                                            colSpan={5}
                                            className="px-4 py-2 bg-white border border-slate-200 text-slate-700 text-base text-center"
                                        >                                                Nenhum anexo enviado.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Status e Observações */}
                <div className="flex flex-col md:flex-row gap-8">
                    <div className="flex-1 flex flex-col gap-4">
                        <div className="text-stone-600 text-base font-medium">Status e Observações</div>
                        <div className="flex flex-col gap-4">
                            <div className="flex flex-col gap-1.5">
                                <FormLabel htmlFor={"statusObra"} isRequired={true}>Status Obra</FormLabel>
                                <div className="bg-white border border-slate-300 rounded-md px-3 py-2 flex items-center justify-between">
                                    <select
                                        name="statusObra"
                                        value={formData.statusObra}
                                        onChange={handleInputChange}
                                        className="grow bg-transparent outline-none text-slate-700 text-base"
                                        required
                                    >
                                        <option value="">Selecionar</option>
                                        {statusList.map((objeto) => (
                                            <option key={objeto.id} value={objeto.id}>
                                                {objeto.nome}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                            <div className="flex flex-col gap-1.5">
                                <label className="text-slate-700 text-sm">Observações</label>
                                <div className="bg-white border border-slate-300 rounded-md px-3 py-2 h-[100px]">
                                    <textarea
                                        name="observacoes"
                                        rows={4}
                                        className="text-slate-700 text-base outline-none w-full resize-none"
                                        value={formData.observacoes}
                                        onChange={handleInputChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Botões de Ação */}

                <div className="flex items-center w-full gap-4">
                    {isEditMode && podeDeletar && (
                        <button
                            type="button"
                            className="px-4 py-2 bg-red-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                            onClick={() => setShowConfirmDeleteRegister(true)}
                        >
                            <img className="w-4 h-4" src="/images/icon/trash-2.png" alt="Apagar" />
                            <span>Apagar</span>
                        </button>
                    )}

                    {isEditMode && podeEmitirRelatorio && (
                        <button
                            type="button"
                            className="px-4 py-2 bg-slate-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                            onClick={exportarRelatorio}
                        >
                            <img className="w-4 h-4" src="/images/icon/pdf.png" alt="Relatório" />
                            <span>Relatório</span>
                        </button>
                    )}

                    <div className="flex gap-4 ml-auto">
                        <button
                            type="button"
                            className="px-4 py-2 bg-stone-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                            onClick={handleBack}
                        >
                            <img className="w-4 h-4" src="/images/icon/arrow-left.png" alt="Voltar" />
                            <span>Voltar</span>
                        </button>

                        <button
                            type="submit"
                            className="px-4 py-2 bg-stone-600 text-white text-sm font-medium rounded-md flex items-center gap-2"
                        >
                            <img className="w-4 h-4" src="/images/icon/save.png" alt="Salvar" />
                            <span>Salvar</span>
                        </button>
                    </div>
                </div>
            </form>

            {/* Modais de Confirmação e Sucesso */}
            <ConfirmationModal
                isVisible={showConfirmDialog}
                onConfirm={handleConfirmSubmit}
                onCancel={handleCancelSubmit}
                message="Deseja salvar as informações?"
            />

            <SuccessModal
                isVisible={showSuccessDialog}
                message="Informações salvas com sucesso!"
                onClose={() => setShowSuccessDialog(false)}
            />

            <ConfirmationModal
                isVisible={showConfirmDeleteRegister}
                onConfirm={handleDeleteRegister}
                onCancel={() => setShowConfirmDeleteRegister(false)}
                message="Deseja apagar este registro?"
                textButtonConfirm="Sim"
            />

            {showDeleteErrorDialog && deleteErrorMessage && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
                    <div className="w-[90%] max-w-[480px] bg-white rounded-lg shadow-xl border border-gray-200 overflow-hidden">
                        <div className="bg-red-50 px-6 py-4 flex items-center gap-3 border-b border-red-100">
                            <div className="w-10 h-10 bg-red-100 rounded-full flex items-center justify-center flex-shrink-0">
                                <svg className="w-6 h-6 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
                                </svg>
                            </div>
                            <h3 className="text-lg font-bold text-red-800">{deleteErrorMessage.titulo}</h3>
                        </div>
                        <div className="px-6 py-4">
                            <p className="text-gray-600 text-sm mb-4">{deleteErrorMessage.descricao}</p>
                            {deleteErrorMessage.dependencias.length > 0 && (
                                <div className="bg-gray-50 rounded-md p-3">
                                    <p className="text-sm font-medium text-gray-700 mb-2">Vínculos encontrados:</p>
                                    <ul className="space-y-1">
                                        {deleteErrorMessage.dependencias.map((dep, idx) => (
                                            <li key={idx} className="text-sm text-gray-600 flex items-center gap-2">
                                                <span className="w-1.5 h-1.5 bg-red-400 rounded-full flex-shrink-0"></span>
                                                {dep}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            )}
                        </div>
                        <div className="px-6 py-4 border-t border-gray-100 flex justify-end">
                            <button
                                onClick={() => setShowDeleteErrorDialog(false)}
                                className="px-5 py-2 bg-stone-600 text-white text-sm font-medium rounded-md hover:bg-stone-700"
                            >
                                Entendi
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <ConfirmationModal
                isVisible={showConfirmRemoveArchiveDialog}
                onConfirm={() => { /* Implementar função para remover arquivo */ }}
                onCancel={() => setShowConfirmRemoveArchiveDialog(false)}
                message="Deseja remover o arquivo deste contrato?"
                textButtonConfirm="Sim"
            />

            {showDialog && (
                <div className="fixed top-0 left-0 w-full h-full bg-black/90 z-50 p-10 flex-col justify-start items-end gap-10 inline-flex overflow-hidden">
                    <div className=" rounded-lg w-full max-w-[80%] h-full max-h-[90%] flex flex-col">
                        <div className="flex justify-between items-center p-4">
                            <div className="flex items-center gap-4">
                                <a href={config.urlArquivo(selectedPdf)} download target="_blank">
                                    <img className="w-6 h-6 relative  overflow-hidden" src="/images/icon/download.png" />
                                </a>
                                <div className="w-6 h-6 relative  overflow-hidden" />
                                <div className="w-6 h-6 relative  overflow-hidden" />
                            </div>
                            <img className="w-6 h-6 relative  overflow-hidden cursor-pointer" src="/images/icon/x.png" onClick={handleCloseDialog} />
                        </div>
                        <div className="flex-grow flex justify-center items-center p-4 overflow-hidden">
                            <iframe
                                src={`${config.urlArquivo(selectedPdf)}#toolbar=0`}
                                className="w-full h-full border-0"
                                style={{ border: 'none' }}
                                title="PDF Viewer"
                            />
                        </div>
                    </div>
                </div>
            )}
        </Template>
    );
};

export default CadastrarObra;
